module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row bg-white max-height-vertical max-height-auto box-overflow"
  }, [_c('full-span-slide', {
    attrs: {
      "active": _vm.active
    }
  }, [_c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _vm._l((_vm.markedParagraphs), function(paragraph) {
    return _c('p', {
      key: paragraph.index,
      domProps: {
        "innerHTML": _vm._s(paragraph)
      }
    })
  }), _vm._v(" "), (_vm.content.text_box) ? _c('div', [_c('textarea', {
    ref: "textarea",
    staticClass: "form-text-area p",
    attrs: {
      "placeholder": _vm.content.text_box
    },
    on: {
      "keyup": _vm.keyCallback
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "transition-1",
    class: _vm.showCaptionClass
  }, [_vm._v("Press "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("ENTER")]), _vm._v(" to submit")])]) : _vm._e()], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ea1043d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/templates/pages/full_page.vue
// module id = 642
// module chunks = 1